import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { TitleSmall } from 'shared/components/text-elements'
import withLocationState from 'shared/components/with-location-state'
import { giphyWhite, giphyBlack, giphyGreen, giphyPurple, giphyBlue, giphyYellow, giphyRed } from '@giphy/js-brand'
import { LogoContainer, LogoSpan, Svg, AnimationOn, AnimationOff } from './sc'

const Section = styled(TitleSmall)`
    font-family: 'nexabook';
    font-size: 38px;
    line-height: 36px;
    color: white;
    margin-left: 6px;
    margin-top: 2px;
`

const Container = styled.div`
    display: flex;
    align-items: center;
`

const ContainerH4 = styled(Container).attrs({ as: 'h4' })``

type Props = {
    headerSubtitle?: string
}

const Logo = ({ headerSubtitle = '' }: Props) => {
    const [isAnimating, setIsAnimating] = useState<boolean>(false)
    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(!isAnimating)
        }, 10000)
        return () => clearInterval(interval)
    })

    return (
        <LogoContainer itemProp="url" href="/">
            <WrappedTitle isHomepage={location.pathname === '/'}>
                <LogoSpan>
                    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 35">
                        <g fillRule="evenodd" clipRule="evenodd">
                            <path fill={giphyGreen} d="M0 3h4v29H0z" />
                            <path fill={giphyPurple} d="M24 11h4v21h-4z" />
                            <path fill={giphyBlue} d="M0 31h28v4H0z" />
                            <path fill={giphyYellow} d="M0 0h16v4H0z" />
                            <path fill={giphyRed} d="M24 8V4h-4V0h-4v12h12V8" />
                            <path fill={giphyBlack} opacity={0.4} d="M24 16v-4h4M16 0v4h-4" />
                        </g>
                        <g fill={giphyWhite}>
                            <path d="M59.1 12c-2-1.9-4.4-2.4-6.2-2.4-4.4 0-7.3 2.6-7.3 8 0 3.5 1.8 7.8 7.3 7.8 1.4 0 3.7-.3 5.2-1.4v-3.5h-6.9v-6h13.3v12.1c-1.7 3.5-6.4 5.3-11.7 5.3-10.7 0-14.8-7.2-14.8-14.3 0-7.1 4.7-14.4 14.9-14.4 3.8 0 7.1.8 10.7 4.4L59.1 12zM68.2 31.2V4h7.6v27.2h-7.6zM88.3 23.8v7.3h-7.7V4h13.2c7.3 0 10.9 4.6 10.9 9.9 0 5.6-3.6 9.9-10.9 9.9h-5.5zm0-6.5h5.5c2.1 0 3.2-1.6 3.2-3.3 0-1.8-1.1-3.4-3.2-3.4h-5.5v6.7zM125 31.2V20.9h-9.8v10.3h-7.7V4h7.7v10.3h9.8V4h7.6v27.2H125zM149.2 13.3l5.9-9.3h8.7v.3l-10.8 16v10.8h-7.7V20.3L135 4.3V4h8.7l5.5 9.3z" />
                        </g>
                    </Svg>
                    {isAnimating ? <AnimationOn /> : <AnimationOff />}
                </LogoSpan>
                {headerSubtitle && <Section>{headerSubtitle}</Section>}
            </WrappedTitle>
        </LogoContainer>
    )
}

const WrappedTitle = (props: any) => (location.pathname === '/' ? <Container {...props} /> : <ContainerH4 {...props} />)
export default withLocationState(['headerSubtitle'])(Logo)
